
import AppRouter from "./routes/router";

function App() {
  return (
     <AppRouter/>
  );
}

export default App;
